import { createI18n } from 'vue-i18n'
import en from '../locales/en.json'
import th from '../locales/th.json'
import zh from '../locales/zh.json'

const messages = {
  en,
  th,
  zh
}

// Available locales configuration
export const availableLocales = [
  { code: 'en', name: 'English', flag: '/icons/flag-en.svg' },
  { code: 'th', name: 'ไทย', flag: '/icons/flag-th.svg' },
  { code: 'zh', name: '中文', flag: '/icons/flag-zh.svg' },
] as const

export type LocaleCode = typeof availableLocales[number]['code']

// Get saved locale or detect from browser
const getInitialLocale = (): LocaleCode => {
  const saved = localStorage.getItem('locale')
  if (saved && ['en', 'th', 'zh'].includes(saved)) {
    return saved as LocaleCode
  }

  // Detect browser language
  const browserLang = navigator.language.split('-')[0]
  if (['en', 'th', 'zh'].includes(browserLang)) {
    return browserLang as LocaleCode
  }

  return 'en'
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
})

export const setLocale = (locale: LocaleCode) => {
  i18n.global.locale.value = locale
  localStorage.setItem('locale', locale)
  document.documentElement.lang = locale
}

export const getCurrentLocale = (): LocaleCode => {
  return i18n.global.locale.value as LocaleCode
}
